import { PagesizeType } from '../../service/pagination/pagesize-type';
/* tslint:disable:no-access-missing-member */
import { AfterViewInit, Component, Inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ReservationCompare } from '../../models/reservation-compare';
import { List } from 'immutable';
import { MatchTypeEnum } from '../../models/match-type.enum';
import { ReservationUtils } from '../../utils/reservation-utils';
import { Rsvp } from '../../models/rsvp';
import { ConfirmationModalComponent } from '../../../shared/confirmation-modal/confirmation-modal.component';
import { Reservation } from '../../models/reservation';
import { EventReservationAction } from '../../models/event-reservation-action';
import { TransientModalComponent } from '../../reservations/transient-modal/transient-modal.component';
import { SummaryRecordTypeEnum } from '../../models/summary-record-type.enum';
import { CompareTableAbstract } from '../../compare-table-abstract';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { LogService } from '../../../shared/log/log.service';
import { PageScrollService } from 'ng2-page-scroll';
import { DOCUMENT } from '@angular/common';
import { RsvpStore } from '../../service/rsvp.store';
import { PaymentStore } from '../../service/payment.store';
import { Page } from '../../../shared/models/page';
import { Subscription } from 'rxjs/Subscription';
import { UserLocalStorageService } from '../../../permission/services/user.local.storage.service';
import { Party } from 'app/event/models/party';
import { AuthenticationStore } from 'app/permission/services/authentication.store';
import { PaymentStatus } from 'app/event/models/payment-status.enum';

@Component({
  selector: 'pioneer-rsvp-compare',
  templateUrl: './rsvp-compare.component.html',
  styleUrls: [ './rsvp-compare.component.css' ]
})
export class RsvpCompareComponent extends CompareTableAbstract implements OnInit, AfterViewInit, OnDestroy {

  private rsvpCompareList: Observable<List<ReservationCompare>>;

  private rsvpToRemove: Rsvp;

  public confirmRsvpModal: EventReservationAction;

  @Input() vendor: Party;

  @ViewChild('confirmDeleteModal')
  public confirmDeleteModal: ConfirmationModalComponent;

  @ViewChild('confirmUpdateRsvpModal')
  public confirmUpdateRsvpModal: ConfirmationModalComponent;

  @ViewChild(TransientModalComponent)
  public transientModal: TransientModalComponent;

  public ui = {
    showCards: false,
    showNoMatchesCard: false,
    showPartialMatchesCard: false,
    showExactMatchesCard: false,
    showNoReservationsWarning: false
  };

  public noMatchPage: Page<ReservationCompare>;
  public partialMatchPage: Page<ReservationCompare>;
  public exactMatchPage: Page<ReservationCompare>;

  noMatchespagesizeType = PagesizeType.RSVP_NO_MATCHES;
  partialMatchespagesizeType = PagesizeType.RSVP_PARTIAL_MATCHES;
  exactMatchespagesizeType = PagesizeType.RSVP_EXACT_MATCHES;

  private matchSubscription: Subscription = new Subscription();

  displayDropdown: boolean;

  constructor(private reservationCompareStore: ReservationCompareStore,
    private authenticationStore: AuthenticationStore,
    private logService: LogService,
    pageScrollService: PageScrollService,
    @Inject(DOCUMENT) document: any,
    rsvpStore: RsvpStore,
    private paymentStore: PaymentStore,
    private userLocalStorageService: UserLocalStorageService) {
    super(pageScrollService,
      document,
      rsvpStore);
    }

  ngOnInit() {
    if (!this.onyxEvent) {
      throw new Error('The "event" attribute must be specified to use the "pioneer-rsvp-compare" component');
    }

    this.rsvpCompareList = this.reservationCompareStore.getVendorCompareList(this.vendor.eventPartyId);

    // all cards
    this.reservationCompareStore.isCompareListEmpty().subscribe((value: boolean) => {
      this.ui.showNoReservationsWarning = value;
      this.ui.showCards = !value;
    });

    // no matches
    this.isMatchListEmpty(MatchTypeEnum.NO_MATCH).subscribe((value: boolean) => {
      this.ui.showNoMatchesCard = !value;
    });

    // partial matches
    this.isMatchListEmpty(MatchTypeEnum.PARTIAL_MATCH).subscribe((value: boolean) => {
      this.ui.showPartialMatchesCard = !value;
    });

    // exact matches
    this.isMatchListEmpty(MatchTypeEnum.EXACT_MATCH).subscribe((value: boolean) => {
      this.ui.showExactMatchesCard = !value;
    });

    this.confirmRsvpModal = EventReservationAction.RSVP_CONFIRMATION;

    this.headerRecordType = SummaryRecordTypeEnum.RSVP;

    if (!this.onyxEvent.eventId) {
      this.displayDropdown = true;
    } else {
      this.paymentStore.getLatestFinalPayment().take(1).subscribe(lastFinalPayment => {
        const hasFinalPayment = Boolean(lastFinalPayment && lastFinalPayment.eventPaymentId);
        this.displayDropdown = !hasFinalPayment || PaymentStatus.REJECTED_WF_APPROVAL === lastFinalPayment.status;
      });
    }

    // Build no matches page
    this.noMatchPage = Page.empty<ReservationCompare>();
    this.noMatchPage.size = this.userLocalStorageService.getPagesize(PagesizeType.RSVP_NO_MATCHES);
    this.buildMatchPage(this.noMatchPage, MatchTypeEnum.NO_MATCH);

    // Build partial matches page
    this.partialMatchPage = Page.empty<ReservationCompare>();
    this.partialMatchPage.size = this.userLocalStorageService.getPagesize(PagesizeType.RSVP_PARTIAL_MATCHES);
    this.buildMatchPage(this.partialMatchPage, MatchTypeEnum.PARTIAL_MATCH);

    // Build exact matches page
    this.exactMatchPage = Page.empty<ReservationCompare>();
    this.exactMatchPage.size = this.userLocalStorageService.getPagesize(PagesizeType.RSVP_EXACT_MATCHES);
    this.buildMatchPage(this.exactMatchPage, MatchTypeEnum.EXACT_MATCH);

  }

  buildMatchPage(matchPage: Page<ReservationCompare>, matchType: MatchTypeEnum) {
    this.matchSubscription.add(this.getMatches(matchType).subscribe(reservationList => {
      const rsvpId = this.reservationCompareStore.selectedRsvpId;
      if (rsvpId) {
        const index = reservationList.findIndex((compare: ReservationCompare) =>
          compare.rsvp && compare.rsvp.eventRsvpId === rsvpId);
        if (index >= 0) {
          matchPage.number = Math.floor(index / matchPage.size);
        }
      }

      const page = matchPage.number;
      const itemsPerPage = matchPage.size;

      matchPage.content = List<ReservationCompare>(
        reservationList.slice(page * itemsPerPage, (page + 1) * itemsPerPage)
      );
      matchPage.totalElements = reservationList.size;
      matchPage.numberOfElements = matchPage.content.size;
    }));
  }

  ngAfterViewInit() {
    const rsvpId = this.reservationCompareStore.selectedRsvpId;
    this.logService.verbose(`rsvp: ${rsvpId}`);

    if (rsvpId) {
      let elem: Element;
      const id = this.getRsvpId(rsvpId);
      elem = document.querySelector(`[data-rsvp-id=${id}]`);
      elem.classList.add('highlight');
      this.logService.verbose(`page scrolling to selector: [data-rsvp-id=${id}]`);
      this.scrollToElement(<HTMLElement>elem);
    }
  }

  ngOnDestroy(): void {
    this.matchSubscription.unsubscribe();
  }

  private get rsvps(): Observable<List<ReservationCompare>> {
    return this.rsvpCompareList;
  }

  getMatches(matchType: MatchTypeEnum): Observable<List<ReservationCompare>> {
    return this.rsvps.map((comparisonList: List<ReservationCompare>) => {
      return comparisonList.filter((comparison: ReservationCompare) => comparison.matchType === matchType.toString()).toList();
    });
  }

  private isMatchListEmpty(matchType: MatchTypeEnum): Observable<boolean> {
    return ReservationUtils.isListEmpty(this.getMatches(matchType));
  }

  confirmBeforeDelete(event: any, rsvp: Rsvp) {
    event.preventDefault();
    this.rsvpToRemove = rsvp;
    this.confirmDeleteModal.open();
  }

  confirmDeleteHandler(deleteConfirmed: boolean) {
    if (deleteConfirmed) {
      this.deleteRsvp(this.rsvpToRemove);
    }

    this.rsvpToRemove = null;
  }

  private deleteRsvp(rsvp: Rsvp): Observable<boolean> {
    rsvp.eventId = this.onyxEvent.eventId;
    const obs = this.rsvpStore.deleteRsvp(rsvp);
    obs.subscribe(() => {
      if (this.isMultiVendor()) {
        this.reservationCompareStore.refreshCurrentRsvpList(this.onyxEvent.eventId);
      } else {
        this.reservationCompareStore.refreshCurrentRsvpListByParty(this.onyxEvent.eventId, this.onyxEvent.eventProperty.eventPartyId);
      }

    });
    return obs;
  }

  openReservationModal(event: any, rsvp: Rsvp) {
    event.preventDefault();
    const reservation = new Reservation({
      firstName: rsvp.firstName,
      lastName: rsvp.lastName,
      nights: rsvp.nights,
      roomRate: rsvp.roomRate,
      eventId: this.onyxEvent.eventId,
      confirmation: rsvp.confirmation,
      checkInDate: rsvp.checkInDate,
      checkOutDate: rsvp.checkOutDate,
      roomType: rsvp.roomType
    });
    this.reservationModal.open(reservation);
  }

  openTransientReservationModal(event: any, rsvp: Rsvp) {
    event.preventDefault();
    this.transientModal.open(rsvp);
  }

  get canManageReservations(): boolean {
    return this.onyxEvent.canManageReservations;
  }

  updateRsvp(rsvpToUpdate: ReservationCompare): Observable<boolean> {
    const obs$ = super.updateRsvp(rsvpToUpdate);
    obs$.subscribe(() => {
      if (this.isMultiVendor()) {
        this.reservationCompareStore.refreshCurrentRsvpList(this.onyxEvent.eventId);
      } else {
        this.reservationCompareStore.refreshCurrentRsvpListByParty(this.onyxEvent.eventId, this.onyxEvent.eventProperty.eventPartyId);
      }

    });
    return obs$;
  }

  onRefreshNoMatchList(pageNumber: number, itemsPerPage: number) {
    this.onRefreshMatchPage(pageNumber, itemsPerPage, MatchTypeEnum.NO_MATCH, this.noMatchPage);
  }

  onRefreshPartialMatchList(pageNumber: number, itemsPerPage: number) {
    this.onRefreshMatchPage(pageNumber, itemsPerPage, MatchTypeEnum.PARTIAL_MATCH, this.partialMatchPage);
  }

  onRefreshExactMatchList(pageNumber: number, itemsPerPage: number) {
    this.onRefreshMatchPage(pageNumber, itemsPerPage, MatchTypeEnum.EXACT_MATCH, this.exactMatchPage);
  }

  private onRefreshMatchPage(pageNumber: number, itemsPerPage: number, matchType: MatchTypeEnum, page: Page<ReservationCompare>) {
    this.getMatches(matchType).take(1).subscribe(reservationList => {
      page.content = List<ReservationCompare>(
        reservationList.slice(pageNumber * itemsPerPage, (pageNumber + 1) * itemsPerPage)
      );
      page.number = pageNumber;
      page.size = itemsPerPage;
      page.totalElements = reservationList.size;
      page.numberOfElements = page.content.size;
    });
  }

  isMultiVendor() {
    return this.authenticationStore.hasPermission('MultiVendor');
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/rsvp-compare/rsvp-compare.component.ts